import React from 'react';
import type { CustomGlyphProps } from '@atlaskit/icon/types';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

const SubtaskIcon = (props: CustomGlyphProps) => (
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g clipPath="url(#clip0_1839_54411)">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9 7V4C9 3.73478 8.89464 3.48043 8.70711 3.29289C8.51957 3.10536 8.26522 3 8 3H4C3.73478 3 3.48043 3.10536 3.29289 3.29289C3.10536 3.48043 3 3.73478 3 4V8C3 8.26522 3.10536 8.51957 3.29289 8.70711C3.48043 8.89464 3.73478 9 4 9H7V12C7 12.2652 7.10536 12.5196 7.29289 12.7071C7.48043 12.8946 7.73478 13 8 13H12C12.2652 13 12.5196 12.8946 12.7071 12.7071C12.8946 12.5196 13 12.2652 13 12V8C13 7.73478 12.8946 7.48043 12.7071 7.29289C12.5196 7.10536 12.2652 7 12 7H9ZM0 1.994C0 0.893 0.895 0 1.994 0H14.006C15.107 0 16 0.895 16 1.994V14.006C15.9997 14.5348 15.7896 15.0418 15.4157 15.4157C15.0418 15.7896 14.5348 15.9997 14.006 16H1.994C1.46524 15.9997 0.958212 15.7896 0.584322 15.4157C0.210432 15.0418 0.000264976 14.5348 0 14.006L0 1.994ZM9 9H11V11H9V9ZM5 5H7V7H5V5Z"
				fill={token('color.icon.subtle', colors.N700)}
				fill-opacity="0.31"
				data-testid={props['data-testid']}
			/>
		</g>
		<defs>
			<clipPath id="clip0_1839_54411">
				<rect width="16" height="16" fill={token('color.icon.inverse', 'white')} />
			</clipPath>
		</defs>
	</svg>
);

export default SubtaskIcon;
